import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { APIService } from './api.service';
import { lastValueFrom } from 'rxjs';

@Injectable({
	providedIn: 'root'
})
export class EnergyService {
	static readonly API_URL = 'https://zlemhivt25.execute-api.eu-west-2.amazonaws.com/v1';

	constructor(private apiService: APIService, private http: HttpClient) { }

	async getMetersForMonth(month: number, year: number): Promise<IGetMetersDaily> {
		const params = new HttpParams().set('action', 'get-meters-month').set('year', year).set('month', month);
		const options = { headers: this.apiService.getUAOHeaders().headers, params };
		const response = await lastValueFrom(this.http.get<any>(EnergyService.API_URL, options));

		response.meters = response.meters.map(m => {
			m.createdAt = new Date(m.createdAt);
			m.firstValueAt = new Date(m.firstValueAt);

			return m;
		});

		return response;
	}

	async getGraphData(assetId: number, start: Date, end: Date, wantsPreviousYear: boolean): Promise<{ labels: any[], dataset1: any[], dataset2: any[] }> {
		const dbDateFrom = this.apiService.dbDate(start);
		const dbDateTo = this.apiService.dbDate(end);
		const params = new HttpParams().set('action', 'get-chart-data').set('assetId', assetId.toString()).set('start', dbDateFrom).set('end', dbDateTo).set('previous', wantsPreviousYear ? "1" : "0");
		const options = { headers: this.apiService.getUAOHeaders().headers, params };
		const response = await lastValueFrom(this.http.get<any>(EnergyService.API_URL, options));

		return response;
	}

	async getMeters(year?: number): Promise<IGetMetersMonthly> {
		const params = new HttpParams().set('action', 'get-meters').set('year', year ?? new Date().getFullYear().toString());
		const options = { headers: this.apiService.getUAOHeaders().headers, params };
		const response = await lastValueFrom(this.http.get<any>(EnergyService.API_URL, options));

		response.meters = response.meters.map(m => {
			m.createdAt = new Date(m.createdAt);
			m.firstValueAt = new Date(m.firstValueAt);

			return m;
		});

		return response;
	}
}

export interface IGetMetersMonthly {
	meters: IMeterItemMonthly[];
	details: {
		minYear: number;
		minDate: Date;
	}
}
export interface IGetMetersDaily {
	meters: IMeterItemDaily[];
	details: {
		minYear: number;
		minDate: Date;
	}
}

export interface IMeterItemMonthly {
	id: number;
	asset_id: number;
	site_title: string;
	gateway_id: string;
	title: string;
	display: string;
	firstvalue: number;
	firstvalueAt: Date;
	createdAt: Date;
	reference: string;
	months: number[];
}

export interface IMeterItemDaily {
	id: number;
	asset_id: number;
	site_title: string;
	gateway_id: string;
	title: string;
	firstvalue: number;
	firstvalueAt: Date;
	createdAt: Date;
	reference: string;
	months: number[];
}
